export default __webpack_public_path__ + "static/media/wyzbox_activation_small.fa858f00.jpg";